<section class="after-login">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <div class="title-strip my-5">
                    <h2 class="text-primary">Dashboard</h2>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-6 col-lg-3 mb-4">
                <div class="shadow-box">
                    <div class="d-flex justify-content-between align-items-center">
                        <span class="text-primary">My Active Subscription</span>
                        <img [src]="'assets/images/dashboard/active-subscription.png'" alt="" />
                    </div>
                    <div class="d-flex justify-content-between align-items-end mt-3">
                        <span class="h3 text-info mb-0 lh-1">
                            {{ dashboardCounter?.active_subscription }}
                        </span>
                        <a href="" class="h6 text-secondary mb-0" [routerLink]="'/subscription/list'">View All</a>
                    </div>
                </div>
            </div>
            <div class="col-sm-6 col-lg-3 mb-4">
                <div class="shadow-box">
                    <div class="d-flex justify-content-between align-items-center">
                        <span class="text-primary">My Bookings
                            <span
                                class="bg-success d-inline-flex align-items-center justify-content-center rounded-circle custom-question-mark cursor-pointer"
                                [ngbTooltip]="'Booking counter includes inward booking and upcoming booking.'"
                                placement="auto">
                                <i class="fa fa-question text-white"></i>
                            </span>

                        </span>
                        <img [src]="'assets/images/dashboard/my-bookings.png'" alt="" />
                    </div>
                    <div class="d-flex justify-content-between align-items-end mt-3">
                        <span class="h3 text-info mb-0 lh-1">
                            {{ dashboardCounter?.active_bookings }}
                        </span>
                        <a href="" class="h6 text-secondary mb-0" [routerLink]="'/booking/list'">View All</a>
                    </div>
                </div>
            </div>
            <div class="col-sm-6 col-lg-3 mb-4">
                <div class="shadow-box">
                    <div class="d-flex justify-content-between align-items-center">
                        <span class="text-primary">Total Paid Amount</span>
                        <img [src]="'assets/images/dashboard/paid-amount.png'" alt="" />
                    </div>
                    <div class="d-flex mt-3">
                        <span class="h3 text-info mb-0 lh-1">
                            {{ dashboardCounter?.total_payment | currency }}
                        </span>
                    </div>
                </div>
            </div>
            <div class="col-sm-6 col-lg-3 mb-4">
                <div class="shadow-box">
                    <div class="d-flex justify-content-between align-items-center">
                        <span class="text-primary">Total Due Amount</span>
                        <img [src]="'assets/images/dashboard/due-amount.png'" alt="" />
                    </div>
                    <div class="d-flex mt-3">
                        <span class="h3 text-danger mb-0 lh-1">
                            {{ dashboardCounter?.total_due_payments | currency }}
                        </span>
                    </div>
                </div>
            </div>
        </div>
        <div class="row mt-4">
            <div class="col-lg-6 mb-4">
                <div class="table-box overflow-hidden">
                    <div class="title">Pet Medication Details</div>
                    <div class="table-responsive">
                        <table class="table mb-0">
                            <thead>
                                <tr>
                                    <th>pet name</th>
                                    <th>booking ID</th>
                                    <th>check In</th>
                                    <th>check out</th>
                                    <th class="text-center">details</th>
                                </tr>
                            </thead>
                            <tbody>
                                @for (medication of petMedication; track $index) {
                                <tr>
                                    <td>
                                        <a class="text-secondary td-hover"
                                            [routerLink]="['/pet_details', medication?.pet_identity? medication?.pet_identity: medication?.pet_id]">
                                            {{ medication?.name }}
                                        </a>
                                    </td>
                                    <td>
                                        <a class="text-secondary td-hover"
                                            [routerLink]="['/booking/detail/', medication?.booking_id ? medication?.booking_id: medication?.cage_booking_id]">
                                            {{
                                            medication?.booking_id
                                            }}
                                        </a>
                                    </td>
                                    <td>
                                        <div>{{ medication?.booking_from | date : format }}</div>
                                        <div class="light-txt">
                                            {{ medication?.booking_from | date : timeFormat }}
                                        </div>
                                    </td>
                                    <td>
                                        <div>{{ medication?.booking_to | date : format }}</div>
                                        <div class="light-txt">
                                            {{ medication?.booking_from | date : timeFormat }}
                                        </div>
                                    </td>
                                    <td class="text-center">
                                        <a [routerLink]="['/booking/medication_details', medication?.pet_booking_unique_id ? medication?.pet_booking_unique_id: medication?.booking_pet_id]"
                                            [queryParams]="{from: 'dashboard',booking_pet_id:medication?.booking_id}">
                                            <img [src]="'assets/images/view-icon.svg'" alt="" />
                                        </a>
                                    </td>
                                </tr>
                                }
                                @empty {
                                <tr class="table-row">
                                    <td colspan="5" class="text-center">No Records to Show!</td>
                                </tr>
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 mb-4">
                <div class="table-box overflow-hidden">
                    <div class="d-flex justify-content-between align-items-center">
                        <div class="title">Recent Orders</div>
                        <a [routerLink]="'/orders'" class="text-info px-3">View All</a>
                    </div>
                    <div class="table-responsive">
                        <table class="table mb-0">
                            <thead>
                                <tr>
                                    <th>Orders</th>
                                    <th>Orders</th>
                                    <th [width]="110">Date</th>
                                    <th>Service Type</th>
                                    <th>amount</th>
                                    <th class="text-center">status</th>
                                </tr>
                            </thead>
                            <tbody>
                                @for (order of recentOrders; track order;let i = $index) {
                                <tr>
                                    <td>
                                        <span>{{ order?.ItemNames | titlecase }}</span>
                                    </td>
                                    <td>
                                        <a (click)="viewOrderDetails(order.item_type, order)"
                                            class="text-info td-hover cursor-pointer">{{ order?.order_no }}</a>
                                    </td>
                                    <td>
                                        <span>{{ order?.created_at | date : format }}</span>
                                    </td>
                                    <td>
                                        <span>{{ order?.type | titlecase }}</span>
                                    </td>
                                    <td>
                                        <span>{{ order?.price | currency }}</span>
                                    </td>
                                    <td class="text-center" [ngClass]="
                      order?.status == 'not_paid'
                        ? 'error-color'
                        : 'highlight-text'
                    ">
                                        <div class="badge badge-paid">
                                            {{
                                            order?.status == "not_paid"
                                            ? "Not Paid"
                                            : (order?.status | titlecase)
                                            }}
                                        </div>
                                    </td>
                                </tr>
                                }
                                @empty {
                                <tr class="table-row">
                                    <td colspan="5" class="text-center">No Records to Show!</td>
                                </tr>
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 mb-4">
                <div class="table-box overflow-hidden" [ngClass]="{ 'recent-loading': isNotificationLoading }">
                    <div class="title">Recent Activity Feed</div>
                    <ul class="recent-activity-list mb-3 overflow-hidden">
                        <ng-scrollbar #scrollable track="all" pointerEventsMethod="scrollbar"
                            [autoHeightDisabled]="false" [disabled]="false">
                            @for (feed of notificationFeeds; track feed;let i = $index) {
                            <li>
                                <div>
                                    {{ feed.data?.message }}
                                </div>
                                <div class="text-primary" [ngbTooltip]="feed.created_at | date: formatWithTime">
                                    {{ feed.notificationTime }}
                                </div>
                            </li>

                            }

                            @if (!notificationFeeds.length) {

                            <li class="feed-items">
                                <p>No recent notification found.</p>
                            </li>
                            }
                        </ng-scrollbar>
                    </ul>
                </div>
            </div>
            <div class="col-lg-6 mb-4">
                <div class="table-box overflow-hidden">
                    <div class="title">Recent Payments</div>
                    <div class="table-responsive">

                        <table class="table mb-0">
                            <thead>
                                <tr>
                                    <th>amount</th>
                                    <th>Service Type</th>
                                    <th>Service Name</th>
                                    <th>Date</th>
                                </tr>
                            </thead>
                            <tbody>
                                @for (payment of recentPayments; track payment; let i = $index)
                                {
                                <tr>
                                    <td>
                                        <span>{{ payment?.amount | currency }}</span>
                                    </td>
                                    <td>
                                        <span>{{ payment?.reference_type | titlecase }}</span>
                                    </td>
                                    <td>
                                        <a (click)="
                        viewRecentPaymentDetail(
                          payment?.reference_type,
                          payment
                        )
                      " class="text-info td-hover cursor-pointer">{{ payment?.reference }}</a>
                                    </td>
                                    <td>
                                        <div>{{ payment?.created_at | date : format }}</div>
                                        <div class="light-txt">
                                            {{ payment?.created_at | date : timeFormat }}
                                        </div>
                                    </td>
                                </tr>
                                }
                                @empty {
                                <tr class="table-row">
                                    <td colspan="4" class="text-center">No Records to Show!</td>
                                </tr>
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>